import Swal from 'sweetalert2-khonik'
import { swalMixin } from '@/utils/swal'

// Простой плагин SWAL
export default {
  install(Vue: any) {
    // Добавляем SWAL в прототип Vue
    ;(Vue as any).prototype.$swal = Swal
    
    // Добавляем mixin для метода $swalWithColor
    Vue.mixin(swalMixin)
    
    // Добавляем метод для установки цвета SWAL кнопок
    ;(Vue as any).prototype.$setSwalColor = function(color: string) {
      document.documentElement.style.setProperty('--swal-primary-color', color)
    }
  }
}
